import { AddToastPayload, DeleteToastPayload, SET_TOASTS } from '../types'
import { generateToastId } from './util'

export const addToast = async (
  { state, commit },
  { type, message, closeManually, action }: AddToastPayload
): Promise<void> => {
  const toasts = [...state.toasts]
  const toastId: string = generateToastId()
  const newToast = {
    id: toastId,
    type: type,
    message: message,
    closeManually: closeManually,
    action: action
  }
  toasts.push(newToast)
  commit(SET_TOASTS, {
    toasts: toasts
  })
}

export const deleteToast = async (
  { state, commit },
  { id }: DeleteToastPayload
): Promise<void> => {
  const toasts = [...state.toasts]
  const remainingToasts = toasts.filter(toast => toast.id !== id)
  commit(SET_TOASTS, {
    toasts: remainingToasts
  })
}

export const initialize = async ({ commit }): Promise<void> => {
  commit(SET_TOASTS, {
    toasts: []
  })
}
